/**
 * BillingAddressForm — Billing address collection with Google Places autocomplete.
 * Extracted from CheckoutPage for reuse in the unified checkout.
 */

import React from 'react';
import {
  Box, TextField, FormControl, InputLabel, Select, MenuItem, Typography
} from '@mui/material';
import AddressAutocomplete from '../AddressAutocomplete';

const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
  'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
  'VT','VA','WA','WV','WI','WY'
];

export default function BillingAddressForm({ address, onChange }) {
  const addr = address || {};

  function update(field, value) {
    onChange({ ...addr, [field]: value });
  }

  function handleAddressSelect(addrData) {
    onChange({
      line1: addrData.street_address || '',
      city: addrData.city || '',
      state: addrData.state || '',
      zip: addrData.zip_code || '',
      country: addrData.country || 'US',
    });
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant="subtitle2">Billing Address</Typography>
      <AddressAutocomplete
        value={addr.line1 || ''}
        onChange={(val) => update('line1', val)}
        onAddressSelect={handleAddressSelect}
        label="Street Address"
        placeholder="Start typing for suggestions..."
        required
      />
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <TextField
          size="small" label="City" value={addr.city || ''}
          onChange={e => update('city', e.target.value)}
          sx={{ flex: 2 }}
          required
        />
        <FormControl size="small" sx={{ flex: 1, minWidth: 80 }}>
          <InputLabel>State</InputLabel>
          <Select value={addr.state || ''} label="State"
            onChange={e => update('state', e.target.value)}>
            <MenuItem value="">--</MenuItem>
            {US_STATES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          size="small" label="ZIP" value={addr.zip || ''}
          onChange={e => update('zip', e.target.value)}
          inputProps={{ maxLength: 10 }}
          sx={{ flex: 1 }}
          required
        />
      </Box>
    </Box>
  );
}
